import { Pipe, PipeTransform } from '@angular/core';

const NON_COUNTRY_CODES = ["ROW", "TIER1", "TIER2", "TIER3", "OTHER", "GLOBAL"]

@Pipe({
  name: 'flag'
})

export class FlagPipe implements PipeTransform {
  transform(value: string): string {
    if (NON_COUNTRY_CODES.includes(value)) return 'hidden';
    return `fi fi-${value.toLowerCase()}`
  }
}